import each from './each';
import isArray from './is-array';
import isNil from './is-nil';
export default (function (data, name) {
    var rst = [];
    var tmpMap = {};
    data.forEach(function (obj) {
        var value = obj[name];
        if (!isNil(value)) {
            // flatten
            if (!isArray(value)) {
                value = [value];
            }
            each(value, function (val) {
                // unique
                if (!tmpMap[val]) {
                    rst.push(val);
                    tmpMap[val] = true;
                }
            });
        }
    });
    return rst;
});
//# sourceMappingURL=values-of-key.js.map